module.exports = __webpack_public_path__ + "img/info-320.aab8576c.png";